/* eslint-disable max-statements */
import React from 'react';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close.svg';
import Button from '@profile/src/Components/Button_V2';
import ImageWithPlaceholder from '@profile/src/Components/ImageWithPlaceHolder';
import { webImageUri } from '@profile/src/utils/uri';
import Spinner from '@profile/src/Components/Spinner';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import { updateAvatar, fetchCosmeticAllInventory } from '@profile/src/redux/actions';
import ErrorView from './ErrorView';
import { formatErrorMessage } from './utils';
import { AppError } from '@profile/src/redux/types';
import PageContent from '@profile/src/Components/PageContent';
import EmptyList from '@profile/src/Components/EmptyList';
import Modal from '@profile/src/Components/Modal';
import classNames from 'classnames';
import { CosmeticType } from '@profile/src/utils/types';
import { CosmeticTabs } from './configs';
import CosmeticTab from './CosmeticTab';
import { makeSelectAvailableCosmetic } from './selectors';

const ChooseAvatarModal = ({
  onClose,
  avatarImage,
  avatarFrameImage
}) => {
  const dispatch = useTypedDispatch();
  const loading = useTypedSelector(state => state.cosmeticAllInventory.loading);
  const invalidated = useTypedSelector(state => state.cosmeticAllInventory.invalidated);
  const selectedCosmetic = useTypedSelector(state => state.selectedCosmetics.data);
  const error = useTypedSelector(state => state.updateAvatar.error);

  const onChangeAvatar = (id, stringImage) => {
    if (id && stringImage) {
      setChosenAvatarId(id);
      setStringImageAvatar(stringImage);
    }
  };

  const onChangeAvatarFrame = (id, stringImage) => {
    if (id && stringImage) {
      setChosenAvatarFrameId(id);
      setStringImageAvatarFrame(stringImage);
    }
  };

  const handleChangeCategory = category => {
    setSelectCategory(category);
  };

  const onClickConfirm = async () => {
    const responseAvatar = chosenAvatarId ? await dispatch(updateAvatar(CosmeticType.AVATAR, [chosenAvatarId])) : undefined;
    const responseAvatarFrame = chosenAvatarFrameId ? await dispatch(updateAvatar(CosmeticType.AVATAR_FRAME, [chosenAvatarFrameId])) : undefined;

    if (!(responseAvatar !== null && responseAvatar !== void 0 && responseAvatar.error) && !(responseAvatarFrame !== null && responseAvatarFrame !== void 0 && responseAvatarFrame.error)) {
      onClose();
      return;
    }

    if (responseAvatar !== null && responseAvatar !== void 0 && responseAvatar.error) {
      setUpdateError(responseAvatar.error);
    }

    if (responseAvatarFrame !== null && responseAvatarFrame !== void 0 && responseAvatarFrame.error) {
      setUpdateError(responseAvatarFrame.error);
    }
  };

  const [chosenAvatarId, setChosenAvatarId] = React.useState(selectedCosmetic === null || selectedCosmetic === void 0 ? void 0 : selectedCosmetic[CosmeticType.AVATAR][0]);
  const [chosenAvatarFrameId, setChosenAvatarFrameId] = React.useState(selectedCosmetic === null || selectedCosmetic === void 0 ? void 0 : selectedCosmetic[CosmeticType.AVATAR_FRAME][0]);
  const [stringImageAvatar, setStringImageAvatar] = React.useState(avatarImage);
  const [stringImageAvatarFrame, setStringImageAvatarFrame] = React.useState(avatarFrameImage);
  const [selectedCategory, setSelectCategory] = React.useState(CosmeticTabs.AVATAR);
  const [updateError, setUpdateError] = React.useState(AppError.NO_ERROR);
  const cosmeticConfigsRes = useTypedSelector(makeSelectAvailableCosmetic(selectedCategory === CosmeticTabs.AVATAR ? CosmeticType.AVATAR : CosmeticType.AVATAR_FRAME));
  const cosmeticConfigs = cosmeticConfigsRes.data;
  const isDisabledButton = (selectedCosmetic === null || selectedCosmetic === void 0 ? void 0 : selectedCosmetic[CosmeticType.AVATAR][0]) === chosenAvatarId && (selectedCosmetic === null || selectedCosmetic === void 0 ? void 0 : selectedCosmetic[CosmeticType.AVATAR_FRAME][0]) === chosenAvatarFrameId || error !== AppError.NO_ERROR;

  const onChangeCosmetic = (id, urlImage) => {
    selectedCategory === CosmeticTabs.AVATAR_FRAME ? onChangeAvatarFrame(id, urlImage) : onChangeAvatar(id, urlImage);
  };

  const renderError = () => {
    if (updateError != AppError.NO_ERROR) {
      return /*#__PURE__*/React.createElement(ErrorView, {
        title: formatErrorMessage(updateError)
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles.placeholder
    }, /*#__PURE__*/React.createElement(EmptyList, {
      title: "Something went wrong, please try again"
    }));
  };

  const renderModalTitle = () => /*#__PURE__*/React.createElement("div", {
    className: styles.avatarContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.avatarPreview
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.avatar
  }, /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: styles.portrait,
    src: stringImageAvatar && webImageUri(stringImageAvatar),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: 175,
      className: styles.portrait
    })
  }), /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: styles.portraitFrame,
    src: stringImageAvatarFrame && webImageUri(stringImageAvatarFrame),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: 175,
      className: styles.portrait
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.btnPreview
  }, /*#__PURE__*/React.createElement("span", null, "Preview"))), /*#__PURE__*/React.createElement("div", {
    className: styles.category
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.categoryItem, selectedCategory === CosmeticTabs.AVATAR && styles.active),
    onClick: () => handleChangeCategory(CosmeticTabs.AVATAR)
  }, /*#__PURE__*/React.createElement("span", null, "Avatar")), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.categoryItem, selectedCategory === CosmeticTabs.AVATAR_FRAME && styles.active),
    onClick: () => handleChangeCategory(CosmeticTabs.AVATAR_FRAME)
  }, /*#__PURE__*/React.createElement("span", null, "Avatar Frame"))));

  const renderLoading = () => /*#__PURE__*/React.createElement("div", {
    className: styles.placeholder
  }, /*#__PURE__*/React.createElement(Spinner, null));

  const renderContent = () => {
    if (cosmeticConfigs && cosmeticConfigs.length > 0) return /*#__PURE__*/React.createElement(CosmeticTab, {
      onChangeCosmetic: onChangeCosmetic,
      chosenId: selectedCategory === CosmeticTabs.AVATAR ? chosenAvatarId : chosenAvatarFrameId,
      cosmeticConfigs: cosmeticConfigs
    });
    return /*#__PURE__*/React.createElement("div", {
      className: styles.placeholder
    }, /*#__PURE__*/React.createElement(EmptyList, {
      title: "Sorry, No result found"
    }));
  };

  React.useEffect(() => {
    setChosenAvatarId(selectedCosmetic === null || selectedCosmetic === void 0 ? void 0 : selectedCosmetic[CosmeticType.AVATAR][0]);
    setChosenAvatarFrameId(selectedCosmetic === null || selectedCosmetic === void 0 ? void 0 : selectedCosmetic[CosmeticType.AVATAR_FRAME][0]);
  }, [selectedCosmetic]);
  React.useEffect(() => {
    dispatch(fetchCosmeticAllInventory());
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "CHANGE AVATAR"), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: styles.close
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  }))), renderModalTitle(), /*#__PURE__*/React.createElement(PageContent, {
    invalidated: invalidated,
    loading: loading,
    error: error !== AppError.NO_ERROR,
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClickConfirm,
    fillWidthAvailable: true,
    title: "Apply",
    disabled: isDisabledButton
  }))));
};

export default ChooseAvatarModal;